
import { uploadJobFiles } from '@/api';
import Button from '@/components/UI/button/Button.vue';
import DropZone from '@/components/UI/dropZone/DropZone.vue';
import { Header } from '@/models/main';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { notificationErrorText } from '@/utils/PortalConstants';

@Component({
  components: {
    Button,
    DropZone,
  },
})
export default class AddImage extends Vue {
  @Prop(Array) private readonly PFiles: File[];
  @Prop({ type: Number, required: false }) private readonly rh_id!: number;
  @Prop({ type: String, required: false }) private readonly rh_date!: string;

  private modal = false;
  private files: File[] = [];
  private filesHeaders: Header[] = [
    { text: 'Name', value: 'name' },
    { text: 'Size', value: 'size', align: 'center' },
    { text: 'Delete', value: 'delete', align: 'center' },
  ];
  @Watch('PFiles', { immediate: true, deep: true })
  private watchToPGoods() {
    if (!this.PFiles) {
      this.files = [];
    }
  }
  private onFilesAdded(files: File[]): void {
    this.files = [...this.files, ...files];
    if (this.files.length > 5) {
      alert('You are only allowed to upload a maximum of 5 files');
      this.files.splice(5);
    }
  }
  private deleteFiles(item: File): void {
    this.files.splice(this.files.indexOf(item), 1);
  }

  private attachFiles(): void {
    const params = {
      rh_id: this.rh_id,
      rh_date: this.rh_date,
      files: this.files,
    };
    uploadJobFiles(params)
      .then(res => {
        this.$emit('changeFiles', this.rh_id, res.data.saved);
        this.modal = false;
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: 'Attachments upload failed',
          text: notificationErrorText,
          type: 'warn',
        });
      });
  }
}
